import React, { useEffect } from "react";
import { ISearchTranslations } from "src/api/types";
import { CheckIcon } from "../icons/check-icon";
import { EditIcon } from "../icons/edit-icon";
import { CloseIcon } from "../icons/close-icon";
import { ArrowDownIcon } from "../icons/arrow-down";
import { ArrowUpIcon } from "../icons/arrow-up";
import { SpinnerIcon } from "../icons/spinner-icon";
import { logger } from "src/lib/utils";

interface TranslationGlobalSearchProps {
  details: ISearchTranslations[];
  editRowIndex: number | null | string | undefined;
  editValue: string | undefined;
  setEditValue: (e: any) => void;
  handleSave: (
    module: string,
    key: string,
    nestedModule?: string,
    nestedKey?: string
  ) => void;
  setEditRowIndex: (e: any) => void;
  openSubMenuDetails: number | null;
  setOpenSubMenuDetails: (e: any) => void;
  editSubRowIndex: {
    parentIndex: number | null;
    subIndex: number | null;
    nestedSubIndex?: number | null;
  };
  setEditSubRowIndex: (e: any) => void;
  loadingUpdateModuleDetails: boolean;
  canEdit?: boolean;
}

const GlobalSearch: React.FC<TranslationGlobalSearchProps> = ({
  details,
  editRowIndex,
  editValue,
  setEditValue,
  handleSave,
  setEditRowIndex,
  openSubMenuDetails,
  setOpenSubMenuDetails,
  editSubRowIndex,
  setEditSubRowIndex,
  loadingUpdateModuleDetails,
  canEdit = true,
}) => {
  return (
    <div className="col-span-9">
      <div className="bg-white p-5 min-h-[500px border]">
        {loadingUpdateModuleDetails ? (
          <div className="flex justify-center items-center w-full min-h-[calc(100vh-70px)]">
            <SpinnerIcon className="h-auto w-5 animate-spin" />
          </div>
        ) : (
          details &&
          details.length > 0 &&
          details.map((item: any, index: number) => (
            <div key={index}>
              <div className="font-bold text-2xl mb-4">{item.module}</div>
              <div className="overflow-auto">
                <table className="w-full text-[16px] font-medium">
                  <tbody>
                    {Object.keys(item.searched_translations).length > 0 &&
                      Object.entries(item.searched_translations).map(
                        ([key, value], idk) => {
                          const rowId = `${index}-${idk}`;
                          if (typeof value === "string") {
                            return (
                              <tr key={rowId}>
                                <td className="py-3 px-2">{key} :</td>
                                {editRowIndex === rowId ? (
                                  <input
                                    type="text"
                                    value={editValue}
                                    onChange={(e) => {
                                      setEditValue(e.target.value);
                                    }}
                                  />
                                ) : (
                                  <td className="py-3 px-2">{value}</td>
                                )}
                                <td className="py-3 px-2">
                                  {editRowIndex === rowId ? (
                                    <>
                                      <button>
                                        <CheckIcon
                                          className="w-[20px] h-[20px] text-primary"
                                          onClick={() =>
                                            handleSave(item.module, key)
                                          }
                                        />
                                      </button>
                                      <button>
                                        <CloseIcon
                                          className="w-[20px] h-[20px] text-primary"
                                          onClick={() => {
                                            setEditRowIndex(null);
                                            setEditValue("");
                                          }}
                                        />
                                      </button>
                                    </>
                                  ) : canEdit ? (
                                    <button>
                                      <EditIcon
                                        className="w-[20px] h-[20px] text-primary"
                                        onClick={() => {
                                          logger.log(idk, " $$$$2222222");
                                          setEditRowIndex(rowId);
                                          setEditValue(value);
                                        }}
                                      />
                                    </button>
                                  ) : null}
                                </td>
                              </tr>
                            );
                          } else if (
                            typeof value === "object" &&
                            value !== null
                          ) {
                            return (
                              <tr key={index}>
                                <td className="py-3 px-2" colSpan={3}>
                                  <div className="py-4">
                                    <div className="flex items-center justify-between bg-[#f1f1f1] rounded-xl p-5">
                                      <h4 className="text-xl font-semibold">
                                        {key}:
                                      </h4>
                                      {openSubMenuDetails === index ? (
                                        <ArrowDownIcon
                                          className="h-[20px] w-[20px] text-secondary"
                                          onClick={() =>
                                            setOpenSubMenuDetails(null)
                                          }
                                        />
                                      ) : (
                                        <ArrowUpIcon
                                          className="h-[20px] w-[20px] text-secondary"
                                          onClick={() => {
                                            logger.log("****78888");
                                            setOpenSubMenuDetails(index);
                                          }}
                                        />
                                      )}
                                    </div>
                                    <div className="overflow-auto">
                                      <div className="w-full">
                                        {openSubMenuDetails === index &&
                                          Object.entries(value).map(
                                            ([subKey, subValue], idx) => {
                                              const isObject =
                                                typeof subValue === "object" &&
                                                subValue !== null;
                                              const isEditing =
                                                editSubRowIndex.parentIndex ===
                                                  index &&
                                                editSubRowIndex.subIndex ===
                                                  idx;

                                              return (
                                                <div
                                                  key={`${index}-${idk}-${idx}`}
                                                  className={`${
                                                    !isObject &&
                                                    "flex items-center gap-2 justify-between"
                                                  } border-b border-dashed border-[#ddd]`}
                                                >
                                                  <div className="p-3">
                                                    {subKey}
                                                  </div>

                                                  {isObject ? (
                                                    Object.entries(
                                                      subValue
                                                    ).map(
                                                      (
                                                        [
                                                          nestedKey,
                                                          nestedValue,
                                                        ]: any,
                                                        nestedIdx
                                                      ) => {
                                                        const isNestedEditing =
                                                          editSubRowIndex.parentIndex ===
                                                            index &&
                                                          editSubRowIndex.subIndex ===
                                                            idx &&
                                                          editSubRowIndex.nestedSubIndex ===
                                                            nestedIdx;

                                                        return (
                                                          <div
                                                            key={nestedIdx}
                                                            className="p-3 flex items-center justify-between"
                                                          >
                                                            <span>
                                                              {nestedKey}
                                                            </span>
                                                            <span>
                                                              {isNestedEditing ? (
                                                                <input
                                                                  type="text"
                                                                  value={
                                                                    editValue
                                                                  }
                                                                  onChange={(
                                                                    e
                                                                  ) => {
                                                                    logger.log(
                                                                      "$$$$333"
                                                                    );
                                                                    setEditValue(
                                                                      e.target
                                                                        .value
                                                                    );
                                                                  }}
                                                                />
                                                              ) : typeof nestedValue ===
                                                                  "string" ||
                                                                typeof nestedValue ===
                                                                  "number" ? (
                                                                nestedValue
                                                              ) : (
                                                                JSON.stringify(
                                                                  nestedValue
                                                                )
                                                              )}
                                                            </span>
                                                            {isNestedEditing ? (
                                                              <>
                                                                <button>
                                                                  <CheckIcon
                                                                    className="w-[20px] h-[20px] text-primary"
                                                                    onClick={() =>
                                                                      handleSave(
                                                                        item.module,
                                                                        nestedKey,
                                                                        key,
                                                                        subKey
                                                                      )
                                                                    }
                                                                  />
                                                                </button>
                                                                <button>
                                                                  <CloseIcon
                                                                    className="w-[20px] h-[20px] text-primary"
                                                                    onClick={() => {
                                                                      logger.log(
                                                                        "$$$$55555"
                                                                      );
                                                                      setEditSubRowIndex(
                                                                        {
                                                                          parentIndex:
                                                                            null,
                                                                          subIndex:
                                                                            null,
                                                                          nestedSubIndex:
                                                                            null,
                                                                        }
                                                                      );
                                                                      setEditValue(
                                                                        ""
                                                                      );
                                                                    }}
                                                                  />
                                                                </button>
                                                              </>
                                                            ) : canEdit ? (
                                                              <button>
                                                                <EditIcon
                                                                  onClick={() => {
                                                                    logger.log(
                                                                      "$$$$66666"
                                                                    );
                                                                    setEditSubRowIndex(
                                                                      {
                                                                        parentIndex:
                                                                          index,
                                                                        subIndex:
                                                                          idx,
                                                                        nestedSubIndex:
                                                                          nestedIdx,
                                                                      }
                                                                    );
                                                                    setEditValue(
                                                                      nestedValue
                                                                    );
                                                                  }}
                                                                  className="w-[20px] h-[20px] text-primary"
                                                                />
                                                              </button>
                                                            ) : null}
                                                          </div>
                                                        );
                                                      }
                                                    )
                                                  ) : (
                                                    <div className="p-3">
                                                      {isEditing ? (
                                                        <input
                                                          type="text"
                                                          value={editValue}
                                                          onChange={(e) => {
                                                            logger.log(
                                                              "$$$$77777"
                                                            );
                                                            setEditValue(
                                                              e.target.value
                                                            );
                                                          }}
                                                        />
                                                      ) : (
                                                        <div className="p-3">
                                                          {subValue}
                                                        </div>
                                                      )}
                                                      <div className="py-3 px-2 text-right">
                                                        {isEditing ? (
                                                          <>
                                                            <button>
                                                              <CheckIcon
                                                                className="w-[20px] h-[20px] text-primary"
                                                                onClick={() =>
                                                                  handleSave(
                                                                    item.module,
                                                                    subKey,
                                                                    key
                                                                  )
                                                                }
                                                              />
                                                            </button>
                                                            <button>
                                                              <CloseIcon
                                                                className="w-[20px] h-[20px] text-primary"
                                                                onClick={() => {
                                                                  logger.log(
                                                                    "$$$$88888"
                                                                  );
                                                                  setEditSubRowIndex(
                                                                    {
                                                                      parentIndex:
                                                                        null,
                                                                      subIndex:
                                                                        null,
                                                                      nestedSubIndex:
                                                                        null,
                                                                    }
                                                                  );
                                                                  setEditValue(
                                                                    ""
                                                                  );
                                                                }}
                                                              />
                                                            </button>
                                                          </>
                                                        ) : canEdit ? (
                                                          <button>
                                                            <EditIcon
                                                              onClick={() => {
                                                                logger.log(
                                                                  "$$$$999999"
                                                                );

                                                                setEditSubRowIndex(
                                                                  {
                                                                    parentIndex:
                                                                      index,
                                                                    subIndex:
                                                                      idx,
                                                                  }
                                                                );
                                                                setEditValue(
                                                                  subValue
                                                                );
                                                              }}
                                                              className="w-[20px] h-[20px] text-primary"
                                                            />
                                                          </button>
                                                        ) : null}
                                                      </div>
                                                    </div>
                                                  )}
                                                </div>
                                              );
                                            }
                                          )}
                                      </div>
                                    </div>
                                  </div>
                                </td>
                              </tr>
                            );
                          }
                        }
                      )}
                  </tbody>
                </table>
              </div>
            </div>
          ))
        )}
      </div>
    </div>
  );
};

export default GlobalSearch;
